export const formatCpf = (cpf: string) => {
  const pattern = /^(\d{3})(\d{3})(\d{3})(\d)/
  return cpf?.replace(pattern, '$1.$2.$3-$4')
}
